import { render, staticRenderFns } from "./Rich.vue?vue&type=template&id=252838b2&"
import script from "./Rich.vue?vue&type=script&lang=js&"
export * from "./Rich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports